import axios from 'axios';

const get = () => axios.get('/fornecedor');
const getDefault = () => axios.get('/fornecedor/default');

export default {
  get,
  getDefault,
};
